import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const KeyboardArrowDownIcon = React.forwardRef<SVGSVGElement, IconProps>(function KeyboardArrowDownIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="M7.41 8.3 12 12.87l4.59-4.57L18 9.7l-6 6-6-6z"/>
        </IconBase>
    );
});
